import * as types from "./actionTypes";
import {getParsedWizardLogic} from "../bvcomponents/priceWorksheet/discountFunctions";
import {IS_AS_WORK_ORDER} from "../config";

export const togglePriceWorksheetOpened = (nextPriceWorksheetOpened) => {
  return (dispatch, getState) => {
    const {priceWorksheetOpened} = getState().priceWorksheetState;
    dispatch({
      type: types.TOGGLE_PRICE_WORKSHEET_OPENED,
      payload: {
        priceWorksheetOpened: nextPriceWorksheetOpened,
        oldStateWorksheetOpened: priceWorksheetOpened,
      }
    })
  }
};

// export const setDiscountSections = (discountSections) => {
//   return (dispatch, getState) => {
//     const {financeCellsVisible} = getState().priceWorksheetState;
//     //     if (currentSection) {
//     //       const discounts = sortByOrder(currentSection.discounts).filter((disc) => !disc.nestedParent);
//     //     }
//     const payload = {
//       discountSections,
//     }
//     if (financeCellsVisible.length !== Object.keys(DISCOUNT_FINANCE_CELLS).length) {
//       const sectionWithFinance = discountSections.find(sec => {
//         return sec.type !== DISCOUNT_SECTION_TYPES.finance && sec.discounts.some(discount => {
//           return discount.discountType === DISCOUNT_SECTION_TYPES.finance
//         })
//       });
//       if (sectionWithFinance) {
//         sectionWithFinance.discounts
//       }
//     }
//     dispatch({
//       type: types.SET_DISCOUNT_SECTIONS,
//       payload
//     })
//   }
// };
export const setDiscountSections = (discountSections) => {
  discountSections = discountSections.filter(discountSection => {
    const parsedWizardLogic = getParsedWizardLogic(discountSection);
    return IS_AS_WORK_ORDER ? parsedWizardLogic.forLowesIME : !parsedWizardLogic.forLowesIME;
  })
  return {
    type: types.SET_DISCOUNT_SECTIONS,
    payload: {
      discountSections,
    }
  }
};

export const setCustomAddedDiscounts = (customAddedDiscounts) => ({
  type: types.SET_CUSTOM_ADDED_DISCOUNTS,
  payload: {customAddedDiscounts}
})

export const setFinancePercentage = (financePercentage) => ({
  type: types.SET_FINANCE_PERCENTAGE,
  payload: {financePercentage}
});

export const setAllFinanceOptionsPopupVisible = (allFinanceOptionsPopupVisible) => ({
  type: types.SET_ALL_FINANCE_OPTIONS_POPUP_VISIBLE,
  payload: {allFinanceOptionsPopupVisible}
});

export const setFinanceCellsVisible = (financeCellsVisible) => ({
  type: types.SET_DISCOUNT_FINANCE_CELLS_VISIBLE,
  payload: {financeCellsVisible}
});

export const restorePriceWorksheetState = (priceWorksheetState) => ({
  type: types.RESTORE_PRICE_WORKSHEET_STATE,
  payload: priceWorksheetState
});

export const setWorkSheetsCount = (discountSections) => {
  const workSheetsCount = discountSections.reduce((maxIndex, discountSection) => {
    const wizardLogic = getParsedWizardLogic(discountSection);
    if ((wizardLogic.index + 1) > maxIndex) {
      maxIndex = wizardLogic.index + 1;
    }
    return maxIndex
  }, 1);
  return {
    type: types.SET_DISCOUNT_WORKSHEET_COUNT,
    payload: {workSheetsCount}
  }
}

// export const setFinanceActiveCompany = (financeActiveCompany) => ({
//   type: types.SET_DISCOUNT_FINANCE_ACTIVE_COMPANY,
//   payload: {financeActiveCompany}
// });

export const setFinancePaymentType = (financePaymentType) => ({
  type: types.SET_DISCOUNT_FINANCE_PAYMENT_TYPE,
  payload: {financePaymentType}
});

export const setFinanceActiveDiscount = (financeActiveDiscount) => ({
  type: types.SET_DISCOUNT_FINANCE_ACTIVE_DISCOUNT,
  payload: {financeActiveDiscount}
});
